/* eslint-disable @typescript-eslint/restrict-template-expressions */
import chroma from 'chroma-js';

import { gradientToCssRule, TGradient } from 'utils/gradientUtils';
import { convertCamelToKebab } from 'utils/string';

import { GGTheme, ThemeColor } from './types';

export const CLASSIC_THEME_TOKEN = '10004-3bcc162b-ae09-4357-9c67-cf4b3d46385c';
export const PLAY_THEME_TOKEN = '10004-7dc3d04a-3120-4b90-82a8-9356f9033949';
export const ORGANIC_THEME_TOKEN = '10004-10f4dd9a-906b-4e02-9b33-eab73a535bc6';
export const CANVAS_THEME_TOKEN = '10004-8f967682-a0e2-44db-b0a2-299eb208ead4';
export const ZEN_THEME_TOKEN = '10004-b621ffcc-1e35-4444-b986-0d2cd020e476';
export const ENERGY_THEME_TOKEN = '10004-a845688e-cc5b-4738-bf93-be10d3ee53e8';
export const BILLBOARD_THEME_TOKEN =
  '10004-d8b3580b-4922-42ce-931b-1c1ac1a7fd5a';

export const getCSSColor = (
  color?: ThemeColor,
  direction?: 'horizontal' | 'vertical',
) => {
  return color && typeof color === 'object'
    ? gradientToCssRule(color, direction)
    : color;
};

const themeColorKeys = [
  'accentPrimary',
  'accentGradient',
  'accentSecondary',
  'accentTertiary',
  'textPrimary',
  'textSecondary',
  'textTertiary',
  'textActive',
  'textError',
  'bgPrimary',
  'bgSecondary',
  'bgTertiary',
  'bgActive',
  'bgError',
];

const getColorVariants = (key: string, color: string) => {
  if (color && color[0] === '#') {
    return ` --${convertCamelToKebab(key)}-10: ${chroma(color).alpha(0.1)};
     --${convertCamelToKebab(key)}-20: ${chroma(color).alpha(0.2)};
     --${convertCamelToKebab(key)}-25: ${chroma(color).alpha(0.25)};
     --${convertCamelToKebab(key)}-40: ${chroma(color).alpha(0.4)};
     --${convertCamelToKebab(key)}-50: ${chroma(color).alpha(0.5)};
     --${convertCamelToKebab(key)}-60: ${chroma(color).alpha(0.6)};`;
  }

  return '';
};

export const getThemeCSSVars = (colors: GGTheme['palette']) => {
  return themeColorKeys.reduce((cssVars: string, key) => {
    const color = colors[key as keyof ThemeColor] as string;
    const colorGradient = colors[key as keyof ThemeColor] as TGradient;

    if (themeColorKeys.includes(key)) {
      return `${cssVars}
     ${
       key === 'accentGradient'
         ? `--accent-primary-vertical: ${getCSSColor(color, 'vertical')};
         --accent-gradient-primary: ${colorGradient.colors[0]};
         --accent-gradient-secondary: ${
           colorGradient.colors[colorGradient.colors.length - 1]
         };
         `
         : `--${convertCamelToKebab(key)}: ${color};`
     }
    ${getColorVariants(key, color)}
     `;
    }

    return cssVars;
  }, '');
};
